import ParkingSchemePage from './components/ParkingSchemePage';
import { ENABLE_PARKING_SCHEME } from '../../configs';

const routes = ENABLE_PARKING_SCHEME ? [
  {
    path: '/parking-scheme',
    name: 'menu.parking-scheme',
    icon: 'parking-meter-marker-clear',
    customIcon: true,
    loginRequired: true,
    component: ParkingSchemePage,
    weight: 102,
    permission: ['frontend_menu_host_monitoring'],
    children: [],
  },
] : [];

export default routes;
